// =============================================================================
// Gerador de QR Code — wrapper da biblioteca "qrcode" (npm, 100% local)
// =============================================================================
// A biblioteca roda inteira no navegador do usuário, sem nenhum serviço
// externo. Usada na tela de Mesas para gerar os QR Codes das mesas.
//
// ATENÇÃO: a lib "qrcode" sobrescreve o style de <canvas> (define width/height
// em 320px) depois do React renderizar — por isso usamos dataURL + <img>,
// onde o CSS/Tailwind controla o tamanho normalmente.
import QRCode from 'qrcode';

export interface OpcoesQrCode {
  /** Largura em pixels do QR gerado (padrão: 320) */
  largura?: number;
  /** Nível de correção de erro: 'L' | 'M' | 'Q' | 'H' (padrão: 'M') */
  nivel?: 'L' | 'M' | 'Q' | 'H';
}

/**
 * Gera o QR Code de `texto` e devolve como dataURL (PNG) para usar em <img>.
 * Exemplo: `const src = await gerarQrCodeDataUrl('http://servidor/?mesa=3')`
 */
export async function gerarQrCodeDataUrl(
  texto: string,
  opcoes: OpcoesQrCode = {},
): Promise<string> {
  return QRCode.toDataURL(texto, {
    width: opcoes.largura ?? 320,
    margin: 2,
    errorCorrectionLevel: opcoes.nivel ?? 'M',
  });
}